import { render, staticRenderFns } from "./item-board.vue?vue&type=template&id=1a0aaf32&"
import script from "./item-board.vue?vue&type=script&lang=js&"
export * from "./item-board.vue?vue&type=script&lang=js&"
import style0 from "./item-board.vue?vue&type=style&index=0&id=1a0aaf32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports